import React, { useEffect } from 'react';

const LLMResponseViewer = ({llmResponse}) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [localLLMResponse, setLocalLLMResponse] = React.useState(llmResponse);

    const rotatingGradient = {
        '@keyframes rotate': {
            '0%': {
                backgroundPosition: '0% 50%'
            },
            '100%': {
                backgroundPosition: '360% 50%'
            }
        }
    };

    const containerStyles = {
        width: '30vw',
        height: '40vh',
        padding: '2px', // Padding creates space for the gradient border
        backgroundSize: '400% 400%', // Background size is 400% to allow for the gradient to rotate
        background: 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 66%, rgba(9,9,121,1) 100%)',
        // background: isFocused
        //     ? 'linear-gradient(124deg, rgba(0,215,37,0.9) 0%, rgba(0,80,255,1) 33%, rgba(9,9,121,1) 100%)' // Attention-grabbing gradient when focused
        //     : 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 100%)', // Original gradient
        //background: 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 100%)', // Gradient from blue to green
        borderRadius: '8px', // Rounds the corners of the border
        boxSizing: 'border-box',
        // transition: 'background 5s ease', // Smooth transition
        animation: isFocused ? 'rotate 10s linear infinite' : 'none',
            '@keyframes rotate': rotatingGradient['@keyframes rotate']
    };

    const textAreaStyles = {
        width: "100%",
        height: '100%',
        fontFamily: 'monospace',
        fontSize: '16px',
        padding: '10px',
        border: 'none', 
        outline: 'none',
        resize: 'none',
        borderRadius: '6px', 
        boxSizing: 'border-box',
        backgroundColor: 'rgb(255, 255, 255)',
    };

    useEffect(() => {
        setLocalLLMResponse(llmResponse);
    }, [llmResponse]);

    return (
        <div style={containerStyles}>
            <textarea
                style={textAreaStyles}
                value={localLLMResponse}
                readOnly
                placeholder="LLM response here ..." 
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
        </div>
    );
};

export default LLMResponseViewer;